<template>
  <div class="item1">
    <div class="title-price">
      <div class="title">{{item.name}}</div>
      <div class="price wechatNumber">-{{item.money}}</div>
    </div>
    <div class="data-time">
      <div class="data">{{item.plan_name}}</div>
      <div class="time">{{item.create_time}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    }
  }
</script>

<style lang="less" scoped>
  .item1 {
    .br(.1rem);
    .bg(#fff);
    .mb(.24rem);
    .p(.28rem .3rem .25rem);
    .title-price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .mb(.15rem);
      .title {
        .fz(.28rem);
        .c(#333);
        font-weight: bold;
      }
      .price {
        .fz(.28rem);
        .c(#00b0f4);
      }
    }
    .data-time {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .fz(.24rem);
      .c(#999);
    }
  }
</style>
